import Modal from "../modal.component";
import { useContext } from "react";
import { SelectedOpenPartOrdersContext } from "../../../contexts/parts/selectedOpenPartOrders.part.context";
import SelectedPartsTable from "../../tables/parts/open/selected/selected.parts.table.component";

const SelectedPartsModal = ({ isOpen, onClose }) => {
  const { selectedOpenPartOrders } = useContext(SelectedOpenPartOrdersContext);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-row gap-4 max-w-full">
        <div
          className="p-4 flex flex-col gap-4 overflow-y-hidden"
          style={{ height: "calc(90vh - 136px)" }}
        >
          {<SelectedPartsTable data={selectedOpenPartOrders} select={true} />}
        </div>
      </div>
    </Modal>
  );
};

export default SelectedPartsModal;
